import React, { useEffect, useState } from "react";
import { Box, Container } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import {
  Profile,
  userFetchTeamStixifyProfileDetail,
} from "../../../services/stixify_api.ts";
import ProfileForm from "./profile_form.tsx";

function StixifyProfileEdit() {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [profile, setProfile] = useState<Profile>();

  useEffect(() => {
    document.title = "Edit Extraction Profile | Stixify Web";
  }, []);

  const loadProfile = async () => {
    if (!id) return;
    const res = await userFetchTeamStixifyProfileDetail(id);
    setProfile(res.data);
  };

  useEffect(() => {
    loadProfile();
  }, []);

  return (
    <Box p={4}>
      {profile && (
        <ProfileForm
          open
          onClose={() => navigate(-1)}
          onAddEntry={() => navigate(-1)}
          entryData={profile}
        />
      )}
    </Box>
  );
}

export default StixifyProfileEdit;
